// extracted by mini-css-extract-plugin
export default {"loading_container":"styles_loading_container__1NPWA","loading_spinne":"styles_loading_spinne__WwHDr","spin":"styles_spin__7ZVuB"};